import React, { forwardRef } from 'react';

const Section = forwardRef(({ children, outerClass, innerClass }, ref) => {
  return (
    <section className={`flex justify-center w-full ${outerClass}`} ref={ref}>
      <div className={`w-full ${innerClass}`}>
        {children}
      </div>
    </section>
  );
});

export default Section;
